import { defineMessages } from 'react-intl';

export const spireMessages = defineMessages({
  htmlTitle: {
    id: 'spire:htmlTitle',
    defaultMessage: 'Spire Enrollment',
    description: 'HTML title for Spire Enrollment page',
  },
  'spire:enrollment-success': {
    id: 'spire:enrollment-success',
    defaultMessage: 'Spire is ready to use!',
    description: 'Success message when Spire enrollment is completed',
  },
  'spire:enrollment-failed': {
    id: 'spire:enrollment-failed',
    defaultMessage: "Couldn't link Spire. Please try again.",
    description: 'Error message when Spire enrollment fails',
  },
  'spire:enrollment-pending': {
    id: 'spire:enrollment-pending',
    defaultMessage: 'Setting up Spire...',
    description: 'Info message when Spire enrollment is pending',
  },
  'spire:status-update-failed': {
    id: 'spire:status-update-failed',
    defaultMessage: 'Something went wrong. Try again.',
    description: 'Error message when status update mutation fails',
  },
});
